var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.5,
    height: 45.5,
    viewBox: "0 0 45.5 45.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.05,
    y1: 0.95,
    x2: 0.905,
    y2: 0.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.045,
    y1: 0.948,
    x2: 0.918,
    y2: -0.052,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.473,28.913l.214-2.451-2.1.567-.937-.937a1.333,1.333,0,0,0-1.885,0L.39,39.465a1.333,1.333,0,0,0,0,1.885l3.76,3.76a1.333,1.333,0,0,0,1.885,0L19.41,31.734a1.333,1.333,0,0,0,0-1.885ZM30.837,0a14.652,14.652,0,0,0-11.26,24.04l-.2,2.462,2.088-.578A14.659,14.659,0,1,0,30.837,0Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.588 10.664)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.649,133.376l-2.989,2.989,1.885,1.885,2.988-2.988A14.8,14.8,0,0,1,189.649,133.376ZM206.241,120H195.577a1.332,1.332,0,0,0-1.333,1.333v5.332A1.332,1.332,0,0,0,195.577,128h10.664a1.332,1.332,0,0,0,1.333-1.333v-5.332A1.332,1.332,0,0,0,206.241,120Z",
    transform: "translate(-186.66 -120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.a2ae9444d182e1ea912d05285bb6ac0f.svg";
export { ForwardRef as ReactComponent };